exports.base_url = "mlkch.afyachat.net/room/";
exports.org = "mlkch";
